import { Expose, plainToClass, Transform, Type } from 'class-transformer';

import { BaseReport } from './base-report-model';
import { BaseStudent } from './base-student-model';
import { TeacherPreferences } from './teacher-preference-model';

export class StudentsReport extends BaseReport {
  @Expose()
  @Transform(({ obj }) => plainToClass(BaseStudent, obj, { strategy: 'excludeAll' }))
  @Type(() => BaseStudent)
  student: BaseStudent;

  @Expose({ name: 'studentPreferance' })
  @Type(() => TeacherPreferences)
  studentPreference: TeacherPreferences;

  @Expose() rate: number;
  @Expose() maqraatecSchool: string;
  @Expose() isPayPackagesBlocked: string;
  @Expose() userId: number;
  @Expose()
  @Transform(({ value }) => value ?? 0)
  walletBalance: number;
}
